import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MigrationApp from './components/MigrationApp';
import reportWebVitals from './reportWebVitals';

/**
 * Authentication System Switch
 * 
 * REACT_APP_USE_COGNITO=true  -> Uses MigrationApp with:
 *   - CognitoLogin component (with password challenge support)
 *   - CognitoAuthContext 
 *   - AWS Cognito authentication
 * 
 * REACT_APP_USE_COGNITO=false -> Uses App with:
 *   - Login component (legacy)
 *   - AuthContext
 *   - Database-based authentication
 */
const USE_COGNITO = process.env.REACT_APP_USE_COGNITO === 'true';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {USE_COGNITO ? <MigrationApp /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
